module.exports = __webpack_public_path__ + "img/outside_thumb.67e53d6c.jpg";